import type { AppProps } from 'next/app';
import type { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';
import '../app/globals.css';
import '../components/TimeSlotPicker';

// Initialize background services (server-side only, has guards for auto-init)
if (typeof window === 'undefined') {
  // This import triggers the auto-initialization of the Viator sync scheduler
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  import('@/services/viatorSyncScheduler').catch(err =>
    console.error('[_app] Failed to initialize services:', err)
  );
}

export default function App({ Component, pageProps }: AppProps<{ session?: Session }>) {
  const { session, ...rest } = pageProps as any;
  return (
    <SessionProvider session={session}>
      <Component {...rest} />
    </SessionProvider>
  );
}
